import { getI18nFromGeneral } from 'src/tools/tools';

export interface ISupplier {
  uuid: string;
  name: string;
}
export interface IWarehouseStock {
  available: number;
  warehouseName: string;
  warehouseUuid: string;
}
export interface IInventory<P> {
  product: P;
  available: number;
  sold: number;
  heldInSet: number;
  total: number;
  uuid: string;
  warehouseStocks: IWarehouseStock[];
}

export enum EEvent {
  StockIn = 'StockIn',
  ManuallyAdded = 'ManuallyAdded',
  ManuallySubtracted = 'ManuallySubtracted',
  AutoAdded = 'AutoAdded',
  AutoSubtracted = 'AutoSubtracted',
  Hold = 'Hold',
  Release = 'Release',
  SetIncreased = 'SetIncreased',
  SetDecreased = 'SetDecreased',
  OrderAdditional = 'OrderAdditional',
  SubscriptionBuy = 'SubscriptionBuy',
}

export const eventDic = {
  [EEvent.StockIn]: getI18nFromGeneral('general.status.stockIn'),
  [EEvent.ManuallyAdded]: getI18nFromGeneral('general.status.manuallyAdded'),
  [EEvent.ManuallySubtracted]: getI18nFromGeneral(
    'general.status.manuallySubtracted',
  ),
  [EEvent.AutoAdded]: getI18nFromGeneral('general.status.refundRestocked'),
  [EEvent.AutoSubtracted]: getI18nFromGeneral('general.status.productSold'),
  [EEvent.Hold]: getI18nFromGeneral('general.status.hold'),
  [EEvent.Release]: getI18nFromGeneral('general.status.release'),
  [EEvent.SetIncreased]: getI18nFromGeneral('general.status.setIncreased'),
  [EEvent.SetDecreased]: getI18nFromGeneral('general.status.setDecreased'),
  [EEvent.OrderAdditional]: getI18nFromGeneral(
    'general.inventory.orderadditionalitem',
  ),
  [EEvent.SubscriptionBuy]: getI18nFromGeneral('general.sider.subscriptionBuy'),
};
